import type { SeriesResponseDto } from '@/generated/model';

import { DIAGRAM_SERIES_GROUP_IDS } from '../../config/seriesConfig';
import type { DiagramSeriesGroup } from '../../types/DiagramSeries.types';

/** The measure channels response lists each group under its own key; the UI needs them as one ordered list. */
export function mapDiagramSeriesMetadata(response: SeriesResponseDto): DiagramSeriesGroup[] {
  return DIAGRAM_SERIES_GROUP_IDS.map((group) => ({
    id: group,
    series: response[group].map((series) => ({ ...series, group })),
  }));
}
